<template lang="pug">
.content
    //- 备注：除不显示站点切换外，本部分与 user.vue 一模一样 
    //- 在这里还是引入 dommain-select 组件
    //- 目的是为了拿到当前的 domainId
    .zone.content-part(style="display: none;")
        domain-select(extra="为网站$domain绑定推广平台账户", @change="onDomainChange")
    setting-title(title="点睛账户绑定")
    .zone.content-part.iframe-header
        TableTitle(slot="icon", icon="fa fa-list", title="绑定推广平台账户列表")
          .tip {{"（可绑定自己及他人账户）"}}
        .header-chart-line
        .zone-search
            a.btn.btn-icon.pull-right(@click="showModal")
                i.fa.fa-plus-circle
                | 添加账户绑定
            input(
                placeholder="输入用户名",
                v-model="query",
                @keyup.enter="searchUsers"
            )
            button.btn.btn-primary.btn-small(@click="searchUsers") 搜索

        table.data-table(style="table-layout: fixed;")
            thead
                tr
                    th(width="6%")
                    th(width="28%") 用户名
                    th(width="30%") 邮箱
                    th(width="20%") 推广平台
                    th(width="10%") 状态
                    th(width="6%") 操作
            tbody
                tr(v-for="(item, index) in listComputed", v-show="!isListEmpty")
                    td {{index + 1}}
                    td {{item.username}}
                    td {{item.useremail}}
                    td {{item.adsystem}}
                    td 
                        span {{item.bstatus | bstatusFilter}}
                    td
                        i.fa.fa-trash-o.fa-lg(
                            title="删除",
                            @click="deleteUser(item, index)"
                        )
                tr(v-show="!isLoading && isListEmpty")
                    td(colspan="8") 暂无数据
                tr(v-show="isLoading && isListEmpty")
                    td(colspan="8")
                        img(src="//p.ssl.qhimg.com/t010aba4345b02168d6.gif")
        v-pagination(:total="total", :pn="pageNum", ps="10", @updatepage="changeListPage")

    v-modal(:visible="modalVisible", title="添加账户绑定", @closemodal="modalVisible = false")
        .modal-content
            div.form
                dl.item
                    dt.label 点睛账户用户名
                    dd.control
                        input.size-normal(v-model="newUserName", ref="userInput", :class="{'error': userNameEmpty}")
        .btn-wrap
            input.btn.btn-primary.btn-small(type="button", value="保存", @click="addNewUser")
            input.btn.btn-default.btn-small(type="button", value="取消", @click="modalVisible = false")

</template>

<script>
    export default {
        data() {
            return {
                domainId: 0,
                list: [],
                query: "",
                newUserName: '',
                pageNum: 1,
                total: 0,
                modalVisible: false,
                isLoading: true,
                userNameEmpty: false
            }
        },
        computed: {
            listComputed() {
                return this.list.map(item => {
                    item.remark = unescape(item.remark || '');
                    return item;
                });
            },
            isListEmpty() {
                return !this.list || !this.list.length;
            }
        },
        methods: {
            showModal() {
                this.modalVisible = true;
                this.newUserName = '';
                this.userNameEmpty = false;
                this.$nextTick(() => {
                    this.$refs.userInput.focus();
                });
            },

            request(url, params, isList) {
                params = _.extend(params, { domainId: this.domainId });
                this.isLoading = !!isList;
                return this.$http.get(url, { params }).then(res => {
                    return res.data;
                }).catch(e => {
                    return { errno: -1, errmsg: '网络错误，请求失败'};
                }).then(data => {
                    this.isLoading = false;
                    return data;
                });
            },

            commonListQuery(query = '', page = 1) {
                this.request('/api/booladsystem/list', {
                    adsystem: 'dianjing',
                    username: query,
                    pg: page,
                    ps: 10
                }, true).then(({ errno, errmsg, list, total }) => {
                    if (errno) return this.$Modal.warn(errmsg);
                    this.list = list;
                    this.total = total;
                });
            },

            changeListPage(num) {
                this.query = _.trim(this.query);
                this.pageNum = num;
                this.commonListQuery(this.query, num);
            },

            searchUsers() {
                // if (!this.query) return this.$Modal.warn('输入内容不能为空');
                this.changeListPage(1);
            },

            addNewUser() {
                let name = _.trim(this.newUserName);
                if (!name) {
                    this.userNameEmpty = true;
                    return;
                }
    
                this.request('/api/booladsystem/bind', {
                    adsystem: 'dianjing',
                    username: name
                }).then(({ errno, errmsg, data}) => {
                    if (errno) return this.$Modal.warn(errmsg);

                    this.$Modal.alert('已发送申请绑定账号邮件到该用户邮箱，对方同意后即可成功绑定点睛账号，查看所绑定点睛账号的全部推广数据');
                    this.list.push(data);
                    this.total++;
                });

                this.modalVisible = false;
                this.newUserName = '';
                this.userNameEmpty = false;
            },

            deleteUser(item, index) {
                this.$Modal.confirm('确定删除?', res => {
                    if (!res) return;
                    this.request('/api/booladsystem/delete', {
                        id: item.id
                    }).then(({ errno, errmsg}) => {
                        if (errno) return this.$Modal.warn(errmsg);
                        this.list.splice(index, 1);
                        this.total--;
                    });
                });
            },

            onDomainChange(domain) {
                this.domainId = domain.id;
                this.pageNum = 1;
                this.total = 0;
                this.query = '';
                this.commonListQuery(this.query, this.pageNum);
            }
        }
    }
</script>

<style scoped>
.zone-search {
    padding: 10px 0;
}
.data-table th,
.data-table td {
    text-align: left;
}
.data-table th:first-child,
.data-table td:first-child {
    text-align: center;
}
td > .fa:hover {
    color: #56bf8b;
}
.eidt-col input {
    width: 140px;
    height: 28px;
}
.iframe-header{ padding-top :0}
</style>



// WEBPACK FOOTER //
// appuser.vue?4726c24a